var Masonry = require("masonry-layout");

console.log(Masonry);

var IconCardsBig = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

IconCardsBig.prototype.init = function(){

  var $container = this.options.$el.find(".masonry-container");

  this.$masonry = new Masonry($container[0],{
    itemSelector: '[data-icon-card-big]',
    gutter: 40
  });

};

export default  IconCardsBig;
